import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from './pages/Landing';
import NotFound from './pages/NotFound';
import UserList from './components/UserList';
import AddUser from './components/addUser';
import EditUser from './components/EditUser';
import EditLanding from './components/EditLanding';
import GenerateQR from './components/GenerateQR';
import Login from './components/Login';
import NavBar from './components/NavBar';

function App() {
  return (
        <BrowserRouter>
          <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/panel-admin" element={
          <>
            <NavBar />
            <UserList />
          </>
        } />
        <Route path="/panel-admin/crear" element={
          <>
            <NavBar />
            <AddUser />
          </>
        } />
        <Route path="/panel-admin/editar/:id" element={
          <>
            <NavBar />
            <EditUser />
          </>
        } />
        <Route path="/panel-admin/editar-landing" element={
          <>
            <NavBar />
            <EditLanding />
          </>
        } />
        <Route path="/panel-admin/qr" element={
          <>
            <NavBar />
            <GenerateQR />
          </>
        } />
        <Route path="/crear" element={
          <>
            <NavBar />
            <AddUser />
          </>
        } />
        <Route path="/editar/:id" element={
          <>
            <NavBar />
            <EditUser />
          </>
        } />
        <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
  );
}

export default App;
